import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { briefsManager, type IBrief } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getAccessControlModule } from '@/store/base/access-control/module';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { mutations } from './mutations';

const BRIEF_MODULE = 'brief';

const dataObjectModule = getDataObjectsModule<IBrief>(briefsManager);
const accessControlModule = getAccessControlModule<IBrief>(briefsManager);
const searchModule = getSearchModule(briefsManager);

const briefModuleInstance = merge<unknown>(dataObjectModule, searchModule, accessControlModule, { actions, mutations });
store.registerModule(BRIEF_MODULE, briefModuleInstance);

export { BRIEF_MODULE };
